export default "__VITE_ASSET__Bg2O$1u3__"